"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Pill.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Pill = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Pill, _React$Component);

  var _super = _createSuper(Pill);

  function Pill(props) {
    (0, _classCallCheck2.default)(this, Pill);
    return _super.call(this, props);
  }

  (0, _createClass2.default)(Pill, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          text = _this$props.text,
          size = _this$props.size;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "pill ".concat(className, " ").concat(size)
      }, text);
    }
  }], [{
    key: "PropTypes",
    get: function get() {
      return {
        className: _propTypes.default.string,
        text: _propTypes.default.string.isRequired,
        size: _propTypes.default.oneOf(['smallest', 'small', '', 'large'])
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        className: '',
        size: ''
      };
    }
  }]);
  return Pill;
}(_react.default.Component);

exports.default = Pill;